import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleCheck, faEyeSlash, faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GetNotifySubscriptionGroupResponse } from "../../../../../../queries/notify";

export function SubscriptionGroupSublabel({ group }: { group: GetNotifySubscriptionGroupResponse }) {
  let icon: IconProp | null = null;
  let text = "";

  switch (true) {
    case group.visibility === "Private":
      icon = faLock;
      text = "Private";
      break;
    case group.visibility === "Unlisted":
      icon = faEyeSlash;
      text = "Unlisted";
      break;
    case group.autoSubscribe:
      icon = faCircleCheck;
      text = "Auto Subscribe";
      break;
    default:
      return null; // No label to display
  }

  return (
    <span>
      <FontAwesomeIcon icon={icon} className='tw-mr-1 tw-text-primary-hint' />
      <span className='tw-text-primary-hint'>{text}</span>
    </span>
  );
}
